import { useState } from "react";
import FormScaffoldResetEvent from "../../../FormScaffold/utils/FormScaffoldResetEvent";
import useSubscribeToFormScaffoldEvent from "../../../FormScaffold/hooks/useSubscribeToFormScaffoldEvent";
import { BaseFormScaffoldState } from "../../../FormScaffold/FormScaffold.types";

export interface UseResetFormParams {
    name: string;
}

export default function useFormGridInput<T extends BaseFormScaffoldState>({ name }: UseResetFormParams) {
    const [value, setValue] = useState();

    function handleResetFormEvent(event: FormScaffoldResetEvent<T>): void {
        // @ts-ignore - avoid breaking the application
        setValue(getValueByPath(event.state, name));
    }

    // skipcq: JS-0323
    function getValueByPath(obj: Record<string, any>, path: string) {
        return path.split(".").reduce((acc, key) => acc?.[key], obj);
    }

    useSubscribeToFormScaffoldEvent(handleResetFormEvent);

    return {
        value,
        setValue,
    };
}
